module.exports = __webpack_public_path__ + "static/media/SKInteracFR_white.945d85fa.png";